import styled from 'styled-components';

export const Container = styled.li`
  padding: 0 45px;
`;
export const Inner = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background-color: #fff;
  box-shadow: 20px 7px 40px rgba(0, 0, 0, 0.2);
  padding: 28px;
  position: relative;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;
export const Image = styled.div`
  position: relative;
  border-radius: 10px;
  box-shadow: 0 0 0 1px #e2e2e2;
  /* cursor: pointer; */
  margin: 0 0 15px;
  overflow: hidden;
  img {
    display: block;
    width: 100%;
    height: auto;
    /*max-height: 175px;*/
    max-height: 100%;
    object-fit: cover;
  }
  &:before,
  &:after {
    content: '';
    position: absolute;
    display: block;
  }
  &:before {
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
  }
  &:after {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border-left: solid 50px rgba(226, 226, 226, 0.32);
    border-top: solid 27px transparent;
    border-bottom: solid 27px transparent;
    z-index: 3;
  }
  &.show-video {
    &:before,
    &:after {
      display: none;
    }
    padding-top: 56.25%;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
    }
  }
`;
export const Text = styled.div`
  color: #333;
  font-size: 16px;
  line-height: 24px;
  margin: 0 0 15px;
`;
export const User = styled.div`
  margin: auto 0 0;
  display: flex;
  align-items: center;
  & > img {
    border-radius: 50%;
    flex: 0 0 70px;
    max-width: 70px;
    min-width: 70px;
    height: 70px;
    max-height: 70px;
    min-height: 70px;
  }
  & > div {
    padding: 0 3px 0 15px;
    flex-grow: 1;
    h3 {
      padding-bottom: 5px;
      /* font-size: 20px; */
      font-size: calc(100vw / 95);
      font-weight: 700;
      color: #333;
    }
    p {
      /* font-size: 20px; */
      font-size: calc(100vw / 95);
      font-weight: 400;
      color: #333;
    }
  }
  & > span {
    flex: 0 0 120px;
    font-size: 14px;
    font-weight: 700;
    /* font-size: calc(100vw / 140); */
    color: #333;
  }
  @media (max-width: 1200px) {
    & > div {
      h3 {
        font-size: calc(100vw / 65);
      }
    }
    & > span {
      padding-left: 5px;
      font-size: calc(100vw / 80);
    }
  }
  @media (max-width: 1200px) {
    position: relative;
    padding-left: 80px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    & > img {
      position: absolute;
      left: 0;
    }
    & > div {
      /* flex: 0 0 100%; */
      flex: 1;
      padding: 0 0 10px 0;
      h3,
      p {
        font-size: 16px;
      }
    }
    & > span {
      /* flex: 0 0 100%; */
      flex: 1;
      padding: 0;
      font-size: 12px;
    }
  }
`;
